import { combineReducers } from 'redux';
import {storeData} from './storeReducer';


const rootReducer = combineReducers({
  storeData
})

export default rootReducer